module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingSenderCompletion"
    }
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "menubutton",
    attrs: {
      "tag": "button",
      "to": "/SpTable",
      "title": "座席予約表に戻る"
    }
  }, [_c('span', [_vm._v("座席予約表に戻る")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("授業振替依頼が完了しました")]), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v("依頼が承認または不承認されたらメールが届きますのでしばらくお待ちください")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5b6c72a4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b6c72a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/ReschedulingPage/SpSenderCompletion.vue
// module id = 723
// module chunks = 0